import { IMAGE_MIME_TYPE } from '@/utils/config'

import { usePhotoUpload } from '@/hooks/photo/usePhotoUpload'

import { SERVICE_BOOKING_IMAGE_PATH } from '@/services'

export const useBookingPhotoUpload = (tokenId) => {
  const { uploadPhoto: innerUploadPhoto, deletePhoto: innerDeletePhoto } =
    usePhotoUpload(false)
  const uploadPhoto = async ({
    file,
    attachmentType,
    onProgress,
    onSuccess,
    onError,
  }) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('attachmentType', attachmentType)
    formData.append('isPhoto', file.type.match(IMAGE_MIME_TYPE) ? 'yes' : 'no')

    return innerUploadPhoto({
      url: SERVICE_BOOKING_IMAGE_PATH.replace('{tokenId}', tokenId),
      file: file,
      formData: formData,
      onProgress,
      onSuccess,
      onError,
      allowAttachments: true,
      isLoginWithToken: true,
    })
  }
  const deletePhoto = async ({ photoId, onSuccess, onError }) => {
    return innerDeletePhoto({
      url: `${SERVICE_BOOKING_IMAGE_PATH.replace('{tokenId}', tokenId)}/${photoId}`,
      onSuccess,
      onError,
      isLoginWithToken: true,
    })
  }
  return { uploadPhoto, deletePhoto }
}
